import { render, staticRenderFns } from "./MeterReadingFailure2.vue?vue&type=template&id=2bda9322&scoped=true&"
import script from "./MeterReadingFailure2.vue?vue&type=script&lang=js&"
export * from "./MeterReadingFailure2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bda9322",
  null
  
)

export default component.exports